<template>
    <div>
        <div class="row mb-3">
            <div class="col-md-2">
                <label>Durchdringungsaufgaben</label><br>
                <b-form-select v-model="is_durchdringung" :options="is_durchdringung_options" class="mt-3" @change="switchIsDurchdringung()" />
            </div>
        </div>
        <div class="row" v-if="is_durchdringung">
            <div class="col-12">
                <div class="card">
                    <div class="card-header card-header-action">
                        <h6>Multiplikatoren</h6>
                        <div class="d-flex align-items-center card-action-wrap">
                            <a class="btn btn-primary btn-xs inline-block text-white" style="cursor: pointer;"
                               v-b-toggle.collapse-2>
                                <i class="ion ion-md-add-circle-outline"></i> Details {{collapsed ? 'ausblenden' :
                                'anzeigen'}}
                            </a>
                        </div>
                    </div>
                    <b-collapse id="collapse-2" v-model="collapsed2">
                        <div class="card-body pb-0">
                            <div class="col-3">
                                <b-button class="btn btn-sm btn-primary w-100" @click="resetMultiplikatoren()">
                                    Multiplikatoren zurücksetzen
                                </b-button>
                            </div>
                        </div>
                        <div v-if="geltungen.length > 0" class="card-body">
                            <div v-for="geltung,key in geltungen">
                                <div class="card mb-15 ml-15 mr-15">
                                    <div class="card-header ">
                                        <div class="d-inline-block float-left">{{ key + 1 }}. Geltungsbereich:
                                            {{geltung.bezeichnung}}
                                        </div>
                                        <div class="d-flex align-items-center card-action-wrap float-right">
                                            <a class="inline-block" href="#" data-effect="fadeOut"
                                               @click="deleteGeltungsbereich(key)">
                                                <i class="ion ion-md-close"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="mt-10 mb-10">
                                                    <h6 class="mt-15">Verantwortliche Personen:</h6>
                                                    <div class="mt-10 mb-10">
                                                        <div v-if="geltung.multiplikatoren.direkte_multiplikator">
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <span class="d-block font-14 font-weight-500 text-dark text-uppercase">Direkte Multiplikatoren</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="geltung.multiplikatoren.direkte_multiplikator.length > 0">
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <span class="d-block font-12 font-weight-500 text-dark text-uppercase">Name</span>
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <span class="d-block font-12 font-weight-500 text-dark text-uppercase">Option</span>
                                                                    </div>
                                                                </div>
                                                                <div v-for="multiplikator,key_multiplikator in geltung.multiplikatoren.direkte_multiplikator">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <!-- <i v-if="verantwortlicher.doppelte"
                                                                                class="ion ion-md-warning text-danger"
                                                                                v-b-tooltip.hover
                                                                                title="Person mehrfach vorhanden"></i>-->
                                                                            <span class="text-info">{{multiplikator.anrede}} {{multiplikator.titel}} {{multiplikator.nachname}}, {{multiplikator.vorname}}</span>
                                                                        </div>
                                                                        <div class="col-md-2">
                                                                            <a href="javascript:void(0)"
                                                                               @click='deleteMitarbeiter(key, key_multiplikator,"direkte_multiplikator", multiplikator)'>
                                                                                <i class="zmdi zmdi-delete font-20 mr-10 text-light-40"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <br>
                                                            </div>
                                                            <div v-else>
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <span class="text-danger">Keine Verantwortlichen festgelegt</span>
                                                                    </div>
                                                                </div>
                                                                <br>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-10 mb-10">
                                                        <div v-if="geltung.multiplikatoren.uebergeordnete_multiplikator">
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <span class="d-block font-14 font-weight-500 text-dark text-uppercase">Übergeordnete Multiplikatoren</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="geltung.multiplikatoren.uebergeordnete_multiplikator.length > 0">
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <span class="d-block font-12 font-weight-500 text-dark text-uppercase">Name</span>
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <span class="d-block font-12 font-weight-500 text-dark text-uppercase">Option</span>
                                                                    </div>
                                                                </div>
                                                                <div v-for="multiplikator,key_multiplikator in geltung.multiplikatoren.uebergeordnete_multiplikator">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <i v-if="multiplikator.doppelte"
                                                                               class="ion ion-md-warning text-danger"
                                                                               v-b-tooltip.hover
                                                                               title="Person mehrfach vorhanden"></i>
                                                                            <span class="text-info">{{multiplikator.anrede}} {{multiplikator.titel}} {{multiplikator.nachname}}, {{multiplikator.vorname}}</span>
                                                                        </div>
                                                                        <div class="col-md-2">
                                                                            <a href="javascript:void(0)"
                                                                               @click='deleteMitarbeiter(key, key_multiplikator,"uebergeordnete_multiplikator", multiplikator)'>
                                                                                <i class="zmdi zmdi-delete font-20 mr-10 text-light-40"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <br>
                                                            </div>
                                                            <div v-else>
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <span class="text-danger">Keine Verantwortlichen festgelegt</span>
                                                                    </div>
                                                                </div>
                                                                <br>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mt-15 ml-15 mr-15 alert alert-info">Keine Multiplikatoren hinterlegt
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    let id = 1;
    export default {
        props: ['geltungen_in', 'is_durchdringung_in', 'signed_api_store_in', 'signed_api_get_aufgabe_typ_in'],
        name: "Durchdringung",
        display: "Durchdringung",
        order: 0,
        components: {},
        data() {
            return {
                enabled: true,
                collapsed: false,
                collapsed2: false,

                geltungen: this.geltungen_in,

                is_durchdringung: !!this.is_durchdringung_in,
                is_durchdringung_options: [
                    { value: true, text: 'Ja' },
                    { value: false, text: 'Nein' }
                ]
            };
        },
        mounted() {
            this.storeAll();
        },
        computed: {},
        methods: {
            deleteGeltungsbereich: function (key) {
                this.geltungen.splice(key, 1);
                this.storeAll();
            },
            deleteMitarbeiter: function (key, key_multiplikator, multiplikator_beziehung, multiplikator) {
                this.geltungen[key].multiplikatoren[multiplikator_beziehung].splice(key_multiplikator, 1);
                this.storeAll();
            },
            switchIsDurchdringung: function () {
                this.storeAll()
            },
            resetMultiplikatoren: function () {
                let self = this;
                axios.post(this.signed_api_get_aufgabe_typ_in, {
                    geltungen: this.geltungen
                }).then(function (res) {
                    self.geltungen = res.data;
                    self.storeAll();
                    self.$swal({
                        title: 'Erfolg',
                        text: "Ihre Änderungen wurden zurückgesetzt",
                        type: 'success',
                        toast: true,
                        position: 'top-right',
                        showConfirmButton: false,
                        timer: 3000
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            storeAll: function () {
                let self = this;
                axios.post(this.signed_api_store_in, {
                    geltungen: this.geltungen,
                    is_durchdringung: this.is_durchdringung
                }).then(function (res) {
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
        }
    };
</script>
<style scoped>
</style>
